import graphql__dda91b14310dd4e20759 from "./__generated__/ContributionsMapContributionTooltip_contributionMarker.graphql.js";
import graphql__df5a03faee92a5b60ea8 from "./__generated__/ContributionsMapContributionTooltipQuery.graphql.js";import { graphql, useFragment } from "react-relay";

import AppQueryRenderer from "../../../AppQueryRenderer";
import MapTooltip from "../../../Maps/MapTooltip";
import Spinner from "../../../Utils/Spinner";
import ContributionsMapContributionTooltipContent from "./ContributionsMapContributionTooltipContent";

const ContributionsMapContributionTooltip = props => {
  const { contributionSlug } = useFragment(
    ContributionsMapContributionTooltip_contributionMarker,
    props.contributionMarker
  );

  return (
    <MapTooltip sticky={true} opacity={1}>
      <AppQueryRenderer
        query={ContributionsMapContributionTooltipQuery}
        variables={{ contributionSlug }}
        component={ContributionsMapContributionTooltipContent}
        loader={<Spinner />}
      />
    </MapTooltip>
  );
};

const ContributionsMapContributionTooltip_contributionMarker = graphql__dda91b14310dd4e20759;

const ContributionsMapContributionTooltipQuery = graphql__df5a03faee92a5b60ea8;

export default ContributionsMapContributionTooltip;
